import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0 32px 0;
  margin-bottom: 18px;
  border-bottom: 1px solid ${({ theme }) => theme.userMenu.line};
`;

export const TopContent = styled.div`
  display: flex;
  width: 100%;
`;

export const Initials = styled.span`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  height: 80px;
  width: 80px;
  font-size: 32px;
  border-radius: 100%;
  color: ${({ theme }) => theme.userMenu.initials};
  background-color: ${({ theme }) => theme.userMenu.initialsBackground};
`;

export const CircleSpin = styled.div`
  position: absolute;
  left: -10px;
  top: -10px;
  width: 100px;
  height: 100px;

  & svg {
    width: 100%;
    height: 100%;
    overflow: initial;
  }

  & circle {
    stroke-width: 3;
    stroke-dasharray: 50, 10;
    fill: none;
    stroke: ${({ theme }) => theme.primaryBackgroundColor};
  }
`;

export const Name = styled.h5`
  margin-top: 32px;
  font-weight: bold;
  color: ${({ theme }) => theme.userMenu.color};
  text-align: center;
  padding: 0 16px;
`;

export const Email = styled.span`
  margin-top: 10px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: center;
  color: ${({ theme }) => theme.userMenu.color};
`;

export const CloseButton = styled.img`
  width: 32px;
  height: 32px;
  position: absolute;
  top: 40px;
  right: 32px;
`;

export const ChangeCompany = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  margin: 10px 0px 0px 0px;
  font-size: 11px;
  text-align: right;
  color: ${ColorPalette.HEX.DimGray};
  cursor: pointer;
  user-select: none;

  &:hover {
    color: ${({ theme }) => theme.primaryBackgroundColor};
  }
`;
